/**
 * Calculates a percentage from current and max values, clamped between 0-100.
 * Returns 0 for invalid inputs (NaN, zero max).
 */
export const clampPercentage = (current: number, max: number): number => {
  if (isNaN(current) || isNaN(max) || max === 0) {
    return 0;
  }
  const percentage = (current / max) * 100;
  return Math.min(100, Math.max(0, Math.round(percentage)));
};

export const ACCEPTED_DATASOURCE_FORMATS = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt'],
  'text/markdown': ['.md'],
  'text/html': ['.html'],
};
